// extracted by mini-css-extract-plugin
export default {"carousel_h3":"ControlledCarousel_carousel_h3__Kb-m8"};